import React from "react";

export const AnytimeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M6.29258 18.3922C3.8868 18.3922 1.93652 16.4419 1.93652 14.0362C1.93652 11.7675 3.67073 9.90399 5.88577 9.69884C6.33887 6.94268 8.73221 4.84003 11.6167 4.84003C14.5011 4.84003 16.8944 6.94268 17.3475 9.69884C19.5626 9.90399 21.2968 11.7675 21.2968 14.0362C21.2968 16.4419 19.3465 18.3922 16.9407 18.3922C12.6913 18.3922 10.013 18.3922 6.29258 18.3922Z"
      strokeWidth="1.93603"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
